import { FC } from 'react';
import { Copy, Edit2, Printer } from 'lucide-react';

import { TextButton } from '../../shared/ui';

/** «Редактировать / Печать / Копировать» in the header of a report block. */
export const DocumentActions: FC = () => (
  <div className="flex items-center gap-4">
    <TextButton tone="muted" underline="none" className="text-ui" startIcon={<Edit2 size={14} />}>
      Редактировать
    </TextButton>
    <TextButton tone="muted" underline="none" className="text-ui" startIcon={<Printer size={14} />}>
      Печать
    </TextButton>
    <TextButton tone="muted" underline="none" className="text-ui" startIcon={<Copy size={14} />}>
      Копировать
    </TextButton>
  </div>
);
